
import { useState } from "react";

import ReactModal from "react-modal";
import moment from "moment";


const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFEBEA",
    padding: "4em",
  },
};


const UserQueryAlert = ({ queryModalData, queryModalFunction, getQuery }) => {
const [query, setQuery] = useState("");

    // const [inputValue, setInputValue] = useState("");

    // const handleChange = (event) => {
    //   setInputValue(event.target.value);
    // };
  console.log("test query Data",queryModalData);
  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= 140) {
      setQuery(value);
      getQuery(value);
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault(); // stops form submission
    }
  };
  
  return (
    <div>
      <ReactModal
        isOpen={queryModalData?.[0]}
        style={customStyles}
        contentLabel="Slot Booking Modal"
        ariaHideApp={false}
      >
        <h3 className="text-navyBlue">Explain Your Query In Brief.</h3>
        <div className="mt-10 mb-20 ">
        <div>
      {/* <label htmlFor="text-input">Enter Your Query:</label> */}
      <textarea
        type="text"
        rows={4}
        placeholder="Type your query here..."
        // onChange = {
        //   (e) => getQuery(e.target.value)
        // } 
        onKeyDown={handleKeyDown}
        onChange={handleChange}

      
        style={{ width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}

      ></textarea>
      <p>{query.length}/140 characters</p>

    </div>
        </div>

        <div className="mt-10 btn-wrapper">
          <button
            className="btn-sm  btn-secondary rounded-5"
            type="button"
           
            onClick={() => {
                queryModalFunction(false,true,queryModalData?.[2],queryModalData?.[3],queryModalData?.[4],queryModalData?.[5]);
            }}
          >
            Book Appointment
          </button>
          <button
          type="button"
            className="btn-sm  btn-navy-blue rounded-5"
            onClick={() => queryModalFunction(false,false)}
          >
            Close
          </button>
        </div>
      </ReactModal>
    </div>
  );
};

export default UserQueryAlert;
